import React from 'react';

import { Typography } from '@mui/material';

import markSrc from '@common/assets/images/exclamation-mark.png';
import { checkRole } from '@common/components/RBAC';
import { useServiceRouter } from '@common/components/ServiceRouter';
import { useConfig } from '@common/modules/Chat/config';
import { getWorkingHoursValue } from '@common/modules/Chat/config/WorkHours';

import * as Styled from './styled';

function ChatRuleMessage() {
	const { checkService } = useServiceRouter();
	const workHours = useConfig(getWorkingHoursValue);
	const isStudent = checkRole('Student');

	return (
		<Styled.Wrap isStudent={isStudent}>
			<Styled.Mark src={markSrc} alt="Exclamation mark" />
			<Typography>
				{isStudent ? (
					<>
						<strong>
							Пам'ятайте, що ми не залишимо нікого без уваги і викладач відповість на запитання
							протягом {workHours} робочих годин.
						</strong>
						{checkService('lyceum')
							? 'Якщо ви зачекались не турбуйтесь, а зверніться до ментора класу'
							: 'Якщо ви зачекались не турбуйтесь, а зверніться до координатора або адміністрації Академії'}
					</>
				) : (
					<>
						Врахуйте, будь ласка: для користувачів сервісу Lyceum доступ до чатів мають також і
						батьки
					</>
				)}
			</Typography>
		</Styled.Wrap>
	);
}

export default ChatRuleMessage;
